import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevWhite.png"
import NagasakiImg from "../../img/NagasakiImg.png"
import ChoiceImg from "../../img/Choice.png"
import NoChoiceImg from "../../img/NoChoice.png"
import ChoiceImg2 from "../../img/Choice2.png"
import NoChoiceImg2 from "../../img/NoChoice2.png"
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import CompanyInfo from "../MenuCompo/CompanyInfo";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
    `,

        Header:styled.div`
            width:90%;
            height:24px;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:row;
            position:fixed;
            z-index:3;
            top:20px;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
        MenuImgBox:styled.div`
            width:100%;
            height:279px;
        `,
            MenuImg:styled.img`
                width:100%;
                height:100%;
            `,
        ContentBox:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:flex-start;
            align-items:flex-start;
            flex-direction:column;
            padding:10px;
        `,
            Title:styled.p`
                font-size:20px;
                font-weight:700;
                color:#181818;
                font-family:'PreFont';
                margin-top:0px;
                margin-bottom:0px;
            `,
            ContentText:styled.p`
                font-size:14px;
                font-weight:400;
                color:#767676;
                font-family:'PreFont';
                margin:0px;
            `,
        Bar:styled.div`
            width:100%;
            height:10px;
            background-color:#F5F5F5;
        `,
        PriceBox:styled.div`
            width:90%;
            height:48px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PriceText:styled.p`
                font-size:16px;
                font-weight:600;
                color:#000000;
                font-family:'PreFont';
                margin:0px;
            `,
        ChoiceWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:column;
        `,
            ChoiceTitleBox:styled.div`
                width:100%;
                height:42px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,
                ChoiceTitle:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#000000;
                    font-family:'PreFont';
                    margin:0px;
                `,
                EssentialBox:styled.div`
                    width:auto;
                    height:auto;
                    padding:4px 6px 4px 6px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                    background-color:#DCEAFF;
                    border-radius:6px;
                `,
                    EssentialText:styled.p`
                        font-size:12px;
                        font-weight:600;
                        color:#2277F6;
                        font-family:'PreFont';
                        margin:0px;
                    `,
                NoEssentialBox:styled.div`
                    width:auto;
                    height:auto;
                    padding:4px 6px 4px 6px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                    background-color:#ECECEC;
                    border-radius:6px;
                `,
                    NoEssentialText:styled.p`
                        font-size:12px;
                        font-weight:600;
                        color:#767676;
                        font-family:'PreFont';
                        margin:0px;
                    `,
            ChoiceBox:styled.div`
                width:100%;
                height:56px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,
                ChoiceBtnBox:styled.div`
                    width:auto;
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                    ChoiceBtnText:styled.p`
                        font-size:16px;
                        font-weight:600;
                        color:#000000;
                        font-family:'PreFont';
                        margin:0px 0px 0px 10px;
                    `,
        NumberWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
            padding:10px;
        `,
            NumberBtnWrap:styled.div`
                width:86px;
                height:30px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,

        Nothing:styled.div`
            width:100%;
            height:100px;
        `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,
}
const MenuSelect=(props)=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);

    const navigate = useNavigate();
    const {ChoiceMenu, setChoiceMenu, OpenMenu, setOpenMenu} = props
    const {
        Menu,
        setGoMenu,
        Pocket,
        setPocket,
    } = useTokenStore()
    const [ChoiceIDX, setChoiceIDX] = useState(-1);
    const [SelectedTaste2, setSelectedTaste2] = useState([]); // 여러 항목의 선택 상태 관리
    const [OrderNum, setOrderNum] = useState(1)


    const toggleTaste2Selection = (idx) => {
        if (SelectedTaste2.includes(idx)) {
            // 이미 선택된 항목이면 해제
            setSelectedTaste2(SelectedTaste2.filter((item) => item !== idx));
        } else {
            // 선택되지 않은 항목이면 추가
            setSelectedTaste2([...SelectedTaste2, idx]);
        }
    };
    useEffect(()=>{
        setGoMenu(false)
    },[])
    function addCommasEveryThirdDigit(number) {
        return number.toLocaleString('en-US');
    }

    function Minus(){
        if(OrderNum===1){

        }else{
            setOrderNum(OrderNum-1)
        }
    }

    const ChoiceBtn = styled.div`
        width: 24px;
        height: 24px;
        background-image: url(${props => props.checked ? ChoiceImg : NoChoiceImg}); // 선택 여부에 따라 이미지 변경
        &:hover {
            cursor: pointer;
        }
    `;
    const ChoiceBtn2 = styled.div`
        width: 24px;
        height: 24px;
        background-image: url(${props => props.checked ? ChoiceImg2 : NoChoiceImg2}); // 선택 여부에 따라 이미지 변경
        &:hover {
            cursor: pointer;
        }
    `;

    function AddPocket() {
        // const newItem = `${Menu.name} 맵기${Taste[ChoiceIDX]}단계 ${OrderNum}개`;
        const selectedAzi = Menu.option[ChoiceIDX]; // object 하나
        const selectedAdditional = SelectedTaste2.map((idx) => Menu.additional[idx]); // object 배열
        const newItem = [{
            Name:Menu.names,
            Azi:selectedAzi,
            Additional:selectedAdditional,
            Num:OrderNum,
            Price:Menu.price,
            Img:Menu.image,
            Id:Menu.id
        }]
        setPocket([...Pocket, newItem]);
        navigate(-1);
    }
    
    const [CostText, setCostText] = useState({
        "KR":"가격",
        "EN":"price",
        "CN":"价格",
        "JP":"価格",
        "FR":"prix",
        "SP":"precio",
        "GR":"Preis",
        "RU":"стоимость"
    })
    const [NumText, setNumText] = useState({
        "KR":"수량",
        "EN":"quantity",
        "CN":"数量",
        "JP":"数量",
        "FR":"quantité",
        "SP":"cantidad",
        "GR":"Anzahl",
        "RU":"количество"
    })
    const [AddToCartText, setAddToCartText] = useState({
        "KR":"장바구니에 담기",
        "EN":"Add to cart",
        "CN":"加入购物车",
        "JP":"カートに入れる",
        "FR":"Ajouter au panier",
        "SP":"Añadir al carrito",
        "GR":"In den Warenkorb legen",
        "RU":"Добавить в корзину"
    })
    const [WonText, setWonText] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    }) 

    const [Option, setOption] = useState({
        "KR":"옵션",
        "EN":"option",
        "CN":"option",
        "JP":"オプション",
        "FR":"option",
        "SP":"option",
        "GR":"option",
        "RU":"option"
    })

    const [Additional, setAdditional] = useState({
        "KR":"추가메뉴",
        "EN":"additional",
        "CN":"附加菜单",
        "JP":"追加メニュー",
        "FR":"menu supplémentaire",
        "SP":"menú adicional",
        "GR":"zusätzliche Auswahl",
        "RU":"дополнительное меню"
    })

    console.log(Menu)

    return(
        <Styled.Wrap>
                <Styled.Header>
                    <Styled.PrevBtn onClick={() => navigate(-1)}>
                        <Styled.PrevImg src={Prev}/>
                    </Styled.PrevBtn>
                </Styled.Header>
            <Styled.MenuImgBox>
                <Styled.MenuImg src={`https://zzikgomainapi.co.kr${Menu.image}`}/>
            </Styled.MenuImgBox>
            <Styled.ContentBox>
                <Styled.Title>{Menu.names[Langcookies["PageLang"]]}</Styled.Title>
                <Styled.ContentText>{Menu.descriptions[Langcookies["PageLang"]]}</Styled.ContentText>
            </Styled.ContentBox>
            <Styled.Bar />
            <Styled.PriceBox>
                <Styled.PriceText>{CostText[Langcookies["PageLang"]]}</Styled.PriceText>
                <Styled.PriceText>{addCommasEveryThirdDigit(Menu.price)}</Styled.PriceText>
            </Styled.PriceBox>
            <Styled.Bar />
            <Styled.ChoiceWrap>
                <Styled.ChoiceTitleBox>
                    <Styled.ChoiceTitle>{Option[Langcookies["PageLang"]]}</Styled.ChoiceTitle>
                    <Styled.EssentialBox>
                        <Styled.EssentialText>필수</Styled.EssentialText>
                    </Styled.EssentialBox>
                </Styled.ChoiceTitleBox>
                {/* {Menu.option.map((v, idx) => (
                    <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                        <Styled.ChoiceBtnBox>
                            <ChoiceBtn
                                checked={ChoiceIDX === idx}
                                onClick={() => setChoiceIDX(idx)}
                            />
                            <Styled.ChoiceBtnText>맵기 {v}단계</Styled.ChoiceBtnText>
                        </Styled.ChoiceBtnBox>
                        <Styled.ChoiceBtnText>+0{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                    </Styled.ChoiceBox>
                ))} */}
                {Menu !== undefined && Langcookies["PageLang"] === "KR" ? Menu.option.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "JP" ? Menu.option_JP.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "CN" ? Menu.option_CN.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "EN" ? Menu.option_EN.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "FR" ? Menu.option_FR.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "DE" ? Menu.option_GR.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "RU" ? Menu.option_RU.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "SP" ? Menu.option_SP.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                  />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
            </Styled.ChoiceWrap>
            <Styled.Bar />
            <Styled.ChoiceWrap>
                <Styled.ChoiceTitleBox>
                    <Styled.ChoiceTitle>{Additional[Langcookies["PageLang"]]}</Styled.ChoiceTitle>
                    <Styled.NoEssentialBox>
                        <Styled.NoEssentialText>선택</Styled.NoEssentialText>
                    </Styled.NoEssentialBox>
                </Styled.ChoiceTitleBox>
                {/* {Taste2.map((v, idx) => (
                    <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                        <Styled.ChoiceBtnBox>
                            <ChoiceBtn2
                                checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                onClick={() => toggleTaste2Selection(idx)}
                            />
                            <Styled.ChoiceBtnText>맵기 {v}단계</Styled.ChoiceBtnText>
                        </Styled.ChoiceBtnBox>
                        <Styled.ChoiceBtnText>+0{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                    </Styled.ChoiceBox>
                ))} */}
                {Menu !== undefined && Langcookies["PageLang"] === "KR" ? Menu.additional.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "JP" ? Menu.additional_JP.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "CN" ? Menu.additional_CN.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "EN" ? Menu.additional_EN.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "FR" ? Menu.additional_FR.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "DE" ? Menu.additional_GR.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "RU" ? Menu.additional_RU.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
                {Menu !== undefined && Langcookies["PageLang"] === "SP" ? Menu.additional_SP.map((v, idx) => {
                    const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                    const value = v[key]; // 예: 0

                    return (
                        <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn2
                                    checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                    onClick={() => toggleTaste2Selection(idx)}
                                />
                                <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    );
                }) : <></>}
            </Styled.ChoiceWrap>
            <Styled.Bar />
            <Styled.NumberWrap>
                <Styled.ChoiceBtnText>{NumText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                <Styled.NumberBtnWrap>
                    <Styled.ChoiceBtnText onClick={Minus}>-</Styled.ChoiceBtnText>
                    <Styled.ChoiceBtnText>{OrderNum}</Styled.ChoiceBtnText>
                    <Styled.ChoiceBtnText onClick={()=>setOrderNum(OrderNum+1)}>+</Styled.ChoiceBtnText>
                </Styled.NumberBtnWrap>
            </Styled.NumberWrap>
            <CompanyInfo />
            <Styled.Nothing />
            <Styled.Footer>
                <Styled.CallBtn onClick={()=>{AddPocket()}}>
                    <Styled.BtnText>{AddToCartText[Langcookies["PageLang"]]}</Styled.BtnText>
                </Styled.CallBtn>
            </Styled.Footer>
        </Styled.Wrap>
    )
}
export default MenuSelect